<div class="history-page">
  <div class="history-card">

    <header class="history-header">
      <span class="eyebrow">Gestión de voluntarios</span>
      <h1>Historial de voluntarios</h1>
      <p>
        Consulta a los voluntarios que ya no están activos y la bitácora de
        cambios de estado de las cuentas.
      </p>
    </header>

    <!-- Pestañas -->
    <nav class="history-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="history-tab"
        [class.active]="activeTab === 'students'"
        [attr.aria-selected]="activeTab === 'students'"
        (click)="setTab('students')"
      >
        Estudiantes pasados
        <span class="tab-count">{{ pastStudents.length }}</span>
      </button>

      <button
        type="button"
        role="tab"
        class="history-tab"
        [class.active]="activeTab === 'volunteers'"
        [attr.aria-selected]="activeTab === 'volunteers'"
        (click)="setTab('volunteers')"
      >
        Voluntarios pasados
        <span class="tab-count">{{ pastVolunteers.length }}</span>
      </button>

      <button
        type="button"
        role="tab"
        class="history-tab"
        [class.active]="activeTab === 'audit'"
        [attr.aria-selected]="activeTab === 'audit'"
        (click)="setTab('audit')"
      >
        Bitácora
        <span class="tab-count">{{ statusAudit.length }}</span>
      </button>
    </nav>

    <div class="history-content">

      @if (isLoading) {
        <div class="history-state">Cargando historial…</div>
      } @else if (loadError) {
        <div class="history-state is-error">
          No se pudo cargar el historial. Intenta de nuevo más tarde.
        </div>
      } @else {

        <!-- =========================================
             PESTAÑA: ESTUDIANTES PASADOS (con horas)
        ========================================== -->
        @if (activeTab === 'students') {
          @if (pastStudents.length === 0) {
            <div class="history-state">No hay estudiantes pasados registrados.</div>
          } @else {
            <div class="table-wrapper">
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Folio</th>
                    <th>Nombre completo</th>
                    <th>Correo</th>
                    <th>Estado</th>
                    <th>Fecha de desactivación</th>
                    <th>Horas acreditadas</th>
                  </tr>
                </thead>
                <tbody>
                  @for (s of pagedPastStudents; track s._id) {
                    <tr>
                      <td class="folio-cell">
                        @if (s.folio) {
                          <app-folio-pill [folio]="s.folio" [showHours]="false"></app-folio-pill>
                        } @else {
                          <span class="folio-badge-table">—</span>
                        }
                      </td>
                      <td>{{ s.nombreCompleto || '—' }}</td>
                      <td>{{ s.email || '—' }}</td>
                      <td>
                        <span class="badge-status">{{ s.accountStatus || '—' }}</span>
                      </td>
                      <td>{{ s.fechaDesactivacion ? (s.fechaDesactivacion | date) : '—' }}</td>
                      <td class="hours-cell">{{ s.horasAcreditadas ?? 0 }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <app-pagination
              [(page)]="studentsPage"
              [totalItems]="pastStudents.length"
              [pageSize]="pageSize"
            ></app-pagination>
          }
        }

        <!-- =========================================
             PESTAÑA: VOLUNTARIOS PASADOS (SIN horas)
        ========================================== -->
        @if (activeTab === 'volunteers') {
          @if (pastVolunteers.length === 0) {
            <div class="history-state">No hay voluntarios pasados registrados.</div>
          } @else {
            <div class="table-wrapper">
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Folio</th>
                    <th>Nombre completo</th>
                    <th>Correo</th>
                    <th>Estado</th>
                    <th>Fecha de desactivación</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of pagedPastVolunteers; track v._id) {
                    <tr>
                      <td class="folio-cell">
                        @if (v.folio) {
                          <app-folio-pill [folio]="v.folio" [showHours]="false"></app-folio-pill>
                        } @else {
                          <span class="folio-badge-table">—</span>
                        }
                      </td>
                      <td>{{ v.nombreCompleto || '—' }}</td>
                      <td>{{ v.email || '—' }}</td>
                      <td>
                        <span class="badge-status">{{ v.accountStatus || '—' }}</span>
                      </td>
                      <td>{{ v.fechaDesactivacion ? (v.fechaDesactivacion | date) : '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <app-pagination
              [(page)]="volunteersPage"
              [totalItems]="pastVolunteers.length"
              [pageSize]="pageSize"
            ></app-pagination>
          }
        }

        <!-- =========================================
             PESTAÑA: BITÁCORA (una fila por transición)
        ========================================== -->
        @if (activeTab === 'audit') {
          @if (statusAudit.length === 0) {
            <div class="history-state">No hay transiciones de estado registradas.</div>
          } @else {
            <div class="table-wrapper">
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Rol</th>
                    <th>Folio</th>
                    <th>Nombre</th>
                    <th>De</th>
                    <th>A</th>
                    <th>Motivo</th>
                    <th>Comentarios</th>
                    <th>Modificado por</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  @for (a of pagedStatusAudit; track $index) {
                    <tr>
                      <td>{{ a.role || '—' }}</td>
                      <td class="folio-cell">
                        <span class="folio-badge-table">{{ a.folio || '—' }}</span>
                      </td>
                      <td>{{ a.nombre || '—' }}</td>
                      <td>
                        <span class="badge-status">{{ a.fromStatus || '—' }}</span>
                      </td>
                      <td>
                        <span class="badge-status">{{ a.toStatus || '—' }}</span>
                      </td>
                      <td>{{ a.reason || '—' }}</td>
                      <td>{{ a.comments || '—' }}</td>
                      <td>{{ a.changedByEmail || '—' }}</td>
                      <td>{{ a.date ? (a.date | date: 'short') : '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <app-pagination
              [(page)]="auditPage"
              [totalItems]="statusAudit.length"
              [pageSize]="pageSize"
            ></app-pagination>
          }
        }

      }

    </div>

  </div>
</div>
